<template>
    <div class='ht-form' :style="{ backgroundImage: `url(${formBg})` }">

        <AreaSelect ref="AreaSelect" @onConfirm="handleConfirm" />

        <div class='title-box'>
            <h5 class='title-text'>免费领取</h5>
            <h6 class='sub-title'>价值888元中文学习礼包</h6>
        </div>

        <div class='form-content'>
            <ul class='form-list'>
                <li class='form-list-item'>
                    <img class='input-icon' :src='userIcon' />
                    <div class='input-box'>
                        <input class='input' placeholder='姓名/Name' v-model.trim="form.name" />
                    </div>
                </li>
                <li class='form-list-item'>
                    <img class='input-icon' :src='phoneIcon' />
                    <div class='input-box phone-input-box'>

                        <div class='phone-code-box'>
                            <div class="phonecode" :class="{ fontColor: !form.phoneCode }" @click="handleSelect">
                                +{{ form.phoneCode || "请选择区号" }}
                            </div>
                        </div>

                        <span class='line'></span>

                        <div class='input-box'>
                            <input class='input' placeholder='手机号/Phone' v-model.trim="form.phone" />
                        </div>

                    </div>
                </li>
                <li class='form-list-item'>
                    <img class='input-icon' :src='wechatIcon' />
                    <div class='input-box'>
                        <input class='input' placeholder='微信/Wachat' v-model.trim="form.contact" />
                    </div>
                </li>
                <li class='form-list-item'>
                    <img class='input-icon' :src='emailIcon' />
                    <div class='input-box'>
                        <input class='input' placeholder='邮箱/Email（选填）' v-model.trim="form.email" />
                    </div>
                </li>
            </ul>

            <div class='btn-box'>
                <div class='btn' @click="handleSubmit">立即领取</div>
            </div>
        </div>

    </div>
</template>

<script>
import formBg from '@/assets/newPromotionImg/form_bg.png'
import userIcon from '@/assets/newPromotionImg/user_icon.svg'
import phoneIcon from '@/assets/newPromotionImg/phone_icon.svg'
import wechatIcon from '@/assets/newPromotionImg/wechat_icon.svg'
import emailIcon from '@/assets/newPromotionImg/email_icon.svg'
import selectDownIcon from '@/assets/newPromotionImg/select_down.svg'
import { postSignup, SendSms } from "@/apis/league"
import AreaSelect from "@/components/AreaSelect"
import { logEvent } from '@/firebaseHatu'

export default {
    components: {
        AreaSelect
    },
    data() {
        return {
            formBg,
            userIcon,
            phoneIcon,
            wechatIcon,
            emailIcon,
            selectDownIcon,

            form: {
                name: "",
                phone: "",
                phoneCode: 86,
                contact: "",
                email: "",
                country: "", // label
            }
        }
    },

    methods: {
        handleConfirm(data) {
            // console.log(data);
            this.form.phoneCode = data.value;
        },
        handleSelect() {
            this.$refs["AreaSelect"].visible = true;
        },
        handleVerify() {
            let form = this.form;
            if (form.phone && form.phoneCode) {
                SendSms(form).then((res) => {
                    // console.log(res);
                    let count = 60;
                    this.count = 60;
                    let timer = setInterval(() => {
                        this.count = count--;
                        if (count === -1) {
                            clearInterval(timer);
                        }
                    }, 1000);
                });
            } else {
                this.$toast("请先完善 国家及地区 / 手机号");
            }
        },
        handleSubmit() {
            let form = this.form;
            if (
                form.name &&
                form.phone &&
                form.phoneCode &&
                // form.country &&
                form.contact
                // form.email
            ) {
                var reg = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
                if (reg.test(form.email) || !form.email) {
                    let {
                        channelId,
                        activityId,
                        userId,
                        applySource,
                    } = this.$route.query;
                    form.userId = userId;
                    if (channelId && activityId) {
                        form.channelId = channelId;
                        form.activityId = activityId;
                        form.applySource = 6;
                    } else if (channelId) {
                        form.channelId = channelId;
                        form.applySource = 6;
                    } else if (applySource == 2) {
                        //是从小程序活动分享的二维码跳转过来的
                        form.applySource = applySource
                        form.activityId = activityId
                    } else {
                        form.applySource = 5;
                    }
                    postSignup(form).then((res) => {
                        // this.$toast("发送成功");
                        if (res.code == 200) {
                            window.ttq.instance(window.HPixelId).track('SubmitForm', {
                                "query": window.location.hash.split("?")[1],
                                status: 'success',
                                formData: form,
                                // "test_event_code": 'TEST22841'
                            })
                            logEvent(`mobileSubmitSuccess`, form)
                            this.$router.push({ path: "/success" });
                        } else {
                            logEvent(`mobileSubmitError`, form)
                            window.ttq.instance(window.HPixelId).track('SubmitForm', {
                                "query": window.location.hash.split("?")[1],
                                status: 'error',
                                formData: form,
                                // "test_event_code": 'TEST22841'
                            })
                        }
                    }).catch(() => {
                        logEvent(`mobileSubmitError`, form)
                        window.ttq.instance(window.HPixelId).track('SubmitForm', {
                            "query": window.location.hash.split("?")[1],
                            status: 'error',
                            formData: form,
                            // "test_event_code": 'TEST22841'
                        })
                    })
                } else {
                    this.$toast("邮箱格式不正确");
                }
            } else {
                let errMessage = '信息不得为空'
                if (!form.contact) {
                    errMessage = '微信号不能为空'
                }
                if (!form.phone) {
                    errMessage = '手机号不能为空'
                }
                if (!form.phoneCode) {
                    errMessage = '区号不能为空'
                }
                if (!form.name) {
                    errMessage = '姓名不能为空'
                }
                this.$toast(errMessage);
            }
            // logEvent(`mobileSubmit`, form)
        },
    },
}
</script>

<style lang="scss" scoped>
.ht-form {
    width: 100%;
    height: 100%;
    background-size: 100% 100%;
    background-repeat: no-repeat;

    .title-box {
        width: 100%;
        padding-top: 50px;

        .title-text,
        .sub-title {
            font-size: 14px;
            color: #fff;
            text-align: center;
            font-weight: 500;
        }

        .sub-title {
            margin-top: 4px;
        }
    }

    .form-content {
        width: 100%;
        box-sizing: border-box;
        // background-color: rgba(255, 0, 0, .5);
        margin-top: 10px;

        .form-list {
            padding: 6px 32px 0 32px;

            .form-list-item {
                padding: 10px 0;
                margin-top: 4px;
                border-bottom: 1px solid rgba(255, 136, 0, .2);
                display: flex;
                align-items: center;
                justify-content: space-between;

                .input-icon {
                    flex: 0 0 21px;
                    width: 21px;
                    height: auto;
                }

                .input-box {
                    flex: 1 1 auto;

                    .input {
                        width: 100%;
                        height: 21px;
                        padding-left: 5px;
                        border: none;
                        outline: none;
                        color: #000;
                        font-size: 13px;

                        &::placeholder {
                            color: #BEBEBE;
                        }
                    }

                    .phone-code-box {
                        .phonecode {
                            font-size: 13px;
                            color: #000;
                            text-align: center;
                        }
                    }
                }

                .phone-input-box {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;

                    .phone-code-box {
                        flex: 0 0 64px;
                    }

                    .line {
                        flex: 0 0 1px;
                        height: 13px;
                        margin: 0 8px;
                        background-color: #BEBEBE;
                    }
                }
            }
        }

        .btn-box {
            padding: 0 32px;
            margin-top: 18px;

            .btn {
                width: 100%;
                height: 38px;
                background-color: #2495B9;
                font-size: 14px;
                color: #fff;
                text-align: center;
                line-height: 38px;
                border-radius: 20px;
                cursor: pointer;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/HtForm/index.vue